import script from "./Icon.vue?vue&type=script&setup=true&lang=js"
export * from "./Icon.vue?vue&type=script&setup=true&lang=js"

import "./Icon.vue?vue&type=style&index=0&id=1d0a3fe8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d0a3fe8"]])

export default __exports__